import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryAdmissionPrep: BlogMetaData = {
  title: '保育園の入園準備リスト｜いつから？持ち物・名前付け・生活リズムの整え方',
  description:
    '保育園の入園準備は何をいつから始める？持ち物リストと名前付けのコツ、入園前の生活リズムの整え方を、子どもと一緒に取り組めるモンテッソーリの視点でわかりやすく解説します。',
  thumbnailUrl: '/img/blog-nursery-admission-prep.webp',
  filePath: buildBlogFilePath('nursery-admission-prep'),
  category: BLOG_CATEGORY.NURSERY,
};
